import { useCallback, useEffect, useState } from 'react';

import { getCategories } from '../../../../api/services/Riders';

type Category = { value: string; label: string };

interface UseTagsHook {
  categories: Category[];
  fetchCategories: () => void;
  isFetching: boolean;
  hasFetched: boolean;
}

export const useCategories = (): UseTagsHook => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const abortController = new AbortController();

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  const fetchCategories = useCallback(async () => {
    setIsFetching(true);
    const response = await getCategories(abortController.signal);

    if (abortController.signal.aborted) {
      return;
    }
    if (response?.type === 'success') {
      setCategories(response?.data.categories || []);
    }
    setIsFetching(false);
    setHasFetched(true);
  }, []);

  return { categories, isFetching, hasFetched, fetchCategories };
};
